import CostSaving from 'elem/compPage/CostSaving';
import CostSavingUs from 'elem/compPage/CostSaving/index-us';
import CostSavingAu from 'elem/compPage/CostSaving/index-au';
import dynamic from 'next/dynamic';
import { useGlobal } from '@/utils/useGlobal';
import PageLayout from '@/components/PageLayout';
import seoconfig from '@/seoconfig/cost-saving';
import SEOlinksA from '@/components/SEOlinksA';
import type { NextPage, GetServerSidePropsContext } from 'next';
import { redirectTo404 } from '@/utils';
import { IPageStatus } from '@elem/compPage/CostSaving/config/IPageStatus';
// 路由跳转白名单
const whiteLocaleList = ['us', 'ca', 'za', 'au'];
export default function CostSavingPage({ SEO, pageStatus }: any) {
    const { useRouter, useEffect, useLang } = useGlobal();
    const { t } = useLang('costsaving');
    const router = useRouter();
    const { locale } = router;
    const GtmPageLoad = dynamic(() => import('@/components/GtmPageLoad'), { ssr: false });

    console.log('pageStatus', pageStatus);
    // useEffect(() => {
    //     if (!['us', 'ca', 'za'].includes(locale)) {
    //         router.push('/404');
    //     }
    // }, []);

    return (
        <PageLayout isNoFixed hideToTop>
            <SEO title={t('seo_title')} description={t('seo_desc')} />
            <SEOlinksA locale={String(locale)} list={seoconfig.include} pathname={seoconfig.url} />
            <GtmPageLoad />
            {locale === 'us' && pageStatus !== IPageStatus.statusA ? <CostSavingUs /> : locale === 'au' ? <CostSavingAu /> : <CostSaving />}
        </PageLayout>
    );
}
export async function getServerSideProps({ locale, query, req }: GetServerSidePropsContext) {
    console.log(locale, query);
    const { debug, _timer } = query;
    // 非白名单404
    if (!whiteLocaleList.includes(locale as string)) {
        return redirectTo404();
    }
    let data = null;
    try {
        data = require(`elem/compPage/CostSaving/config/times/${locale}.js`);
    } catch (err) {
        data = require(`elem/compPage/CostSaving/config/times/us.js`);
    }
    const timeLine = data.timeLine || null; // 代码保存的时间线
    // 时间节点判断 正式环境未开始重定向404
    const time = new Date().getTime(); // 服务器时区北京时区

    let currentTime = time;
    let pageStatus = currentTime >= timeLine?.statusA?.start ? IPageStatus.statusA : '';

    if (debug && !_timer) {
        if (debug === IPageStatus.statusA) {
            pageStatus = IPageStatus.statusA;
        } else if (debug === IPageStatus.statusB) {
            pageStatus = IPageStatus.statusB;
        }
        // else {
        //     return redirectTo404();
        // }
    }

    if (_timer) {
        currentTime = new Date(`${_timer} GMT+8`).getTime();
    }

    if (timeLine) {
        if (currentTime >= timeLine?.statusB?.start) {
            pageStatus = IPageStatus.statusB;
        } else if (currentTime >= timeLine?.statusA?.start) {
            pageStatus = IPageStatus.statusA;
        }
        // else {
        //     return redirectTo404();
        // }
    }

    // 获取登陆信息
    const userInfoJson = req.cookies?.userInfo || '';
    let isLogin = false;
    try {
        const userInfo = JSON.parse(userInfoJson);
        isLogin = !!userInfo.token;
    } catch {}

    return {
        props: {
            timeLine: timeLine,
            pageStatus: pageStatus,
            isLogin,
        },
    };
}
